import atomicKetchup from "../assets/eras/atomic.webp";
import cretaceous from "../assets/eras/cretaceous.webp";
import genePatent from "../assets/eras/gene-patent.webp";
import singularity from "../assets/eras/singularity.webp";
import steamCannery from "../assets/eras/steam-cannery.webp";
import sunGarden from "../assets/eras/sun-garden.webp";

export const ERA_IMAGE_URLS: Readonly<Record<string, string>> = {
  "cretaceous": cretaceous,
  "sun-gardens": sunGarden,
  "steam-cannery": steamCannery,
  "atomic-ketchup": atomicKetchup,
  "gene-patent": genePatent,
  "singularity": singularity,
};
